// extracted by mini-css-extract-plugin
module.exports = {"modal":"CookieConsent_modal__eUZ5f","inner":"CookieConsent_inner__R9T0d","header":"CookieConsent_header__pp5fv","actions":"CookieConsent_actions__FVPJ1"};